var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItemIcon, ListItemText, MenuItem, } from '@material-ui/core';
import { LiveHelp, } from '@material-ui/icons';
import { FaqDialog } from './FaqDialog';
export function FaqMenuItem(_a) {
    var faqs = _a.faqs;
    var t = useTranslation().t;
    var _b = __read(useState(false), 2), showDialog = _b[0], setShowDialog = _b[1];
    if (!(faqs === null || faqs === void 0 ? void 0 : faqs.length))
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { onClick: function () { return setShowDialog(true); } },
            React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
                React.createElement(LiveHelp, { color: "primary" })),
            React.createElement(ListItemText, { primary: t('Help Center') })),
        React.createElement(FaqDialog, { faqs: faqs, open: showDialog, closeDialog: function () { return setShowDialog(false); } })));
}
//# sourceMappingURL=FaqMenuItem.js.map